import React from 'react';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import LifetimeRatingVolumeByStarRatingChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewRatings/LifetimeRatingVolumeByStarRatingChart';
import ProductCatalogCountRatingChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewRatings/ProductCatalogCountRatingChart';
import ProductCatalogCountRatingVolumeChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewRatings/ProductCatalogCountRatingVolumeChart';
import ReviewChildWeeklyRatingVolumeProductChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewRatings/ReveiwWeeklyRatingVolumeProductChart';
import ReviewRatingDoubleDropdownByCategoryChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewRatings/ReviewRatingDoubleDropdownByCategoryChart';
import { WeeklyRatingTable } from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewRatings/WeeklyRatingTable';
import WeeklyRatingVolumeByStarRatingChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewRatings/WeeklyRatingVolumeByStarRatingChart';
import ReviewSummaryProductGrid from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewSummary/ReviewSummaryProductGrid';
import { useReviewCumulativeValues } from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewsHooks';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { EntityNoDataPlaceHolder } from 'src/components/BeaconV2Components/common/NoDataPlaceHolder/NoDataPlaceHolder';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import { useCategoryEntity, useProductEntity, useSubcategoryEntity } from 'src/utils/Hooks/reduxSelectors';
import { useFieldLevel } from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewsHooks';
import ReviewWeeklyRatingVolumeChart from 'src/components/BeaconV2Components/ExperimentalLayout/Reviews/ReviewRatings/ReviewWeeklyRatingVolumeChart';
import { ChartContextProvider } from 'src/utils/chartContext/ChartContextGroupContext';
import { CHART_CONTEXT_GROUPS, CHART_NAMES } from 'src/utils/chartContext/chartContextRegistry';

const ReviewRatingsPage = () => {
  const { isProductEntity } = useProductEntity();
  const { isCategoryEntity } = useCategoryEntity();
  const { isSubcategoryEntity } = useSubcategoryEntity();
  const fieldLevel = useFieldLevel();

  const { reviewCumulativeCountData, reviewCumulativeCountLoading } = useReviewCumulativeValues({
    aggregationFieldNames: [`${fieldLevel}LifetimeRatingVolume`]
  });

  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        {!reviewCumulativeCountLoading && reviewCumulativeCountData?.length === 0 ? (
          EntityNoDataPlaceHolder
        ) : (
          <>
            {/* Weekly rating volume */}
            {/* <ReviewWeeklyRatingVolumeChart />
            {isProductEntity && <ReviewChildWeeklyRatingVolumeProductChart />}
 */}
            {/* Weekly Rating Volume by Star Rating */}
            {/* <WeeklyRatingVolumeByStarRatingChart /> */}
            {/* Cumulative Rating Volume by Star Rating */}
            <ChartContextProvider
              group={CHART_CONTEXT_GROUPS.BEACON_LIFETIME_RATING_BY_STAR.name}
              chartName={CHART_NAMES.BEACON_LIFETIME_RATING_BY_STAR_COLUMN}
              chartTitle="Cumulative Rating Volume by Star Rating"
            >
              <LifetimeRatingVolumeByStarRatingChart />
            </ChartContextProvider>
            {!isProductEntity && (
              <ChartContextProvider
                group={CHART_CONTEXT_GROUPS.BEACON_RATING_CATALOG_COUNT_VOLUME.name}
                chartName={CHART_NAMES.BEACON_RATING_CATALOG_COUNT_VOLUME_COLUMN}
                chartTitle="Product Catalog Count by Rating Volume"
              >
                <ProductCatalogCountRatingVolumeChart />
              </ChartContextProvider>
            )}
            {!isProductEntity && (
              <ChartContextProvider
                group={CHART_CONTEXT_GROUPS.BEACON_RATING_CATALOG_COUNT_RATING.name}
                chartName={CHART_NAMES.BEACON_RATING_CATALOG_COUNT_RATING_COLUMN}
                chartTitle="Product Catalog Count by Rating"
              >
                <ProductCatalogCountRatingChart />
              </ChartContextProvider>
            )}
            {!isCategoryEntity && !isSubcategoryEntity && !isProductEntity && (
              <ChartContextProvider
                group={CHART_CONTEXT_GROUPS.BEACON_RATING_BY_CATEGORY.name}
                chartName={CHART_NAMES.BEACON_RATING_BY_CATEGORY_COLUMN}
                chartTitle="Ratings by Category"
              >
                <ReviewRatingDoubleDropdownByCategoryChart groupByField="categoryId" />
              </ChartContextProvider>
            )}
            {!isSubcategoryEntity && !isProductEntity && (
              <ChartContextProvider
                group={CHART_CONTEXT_GROUPS.BEACON_RATING_BY_SUBCATEGORY.name}
                chartName={CHART_NAMES.BEACON_RATING_BY_SUBCATEGORY_COLUMN}
                chartTitle="Ratings by Subcategory"
              >
                <ReviewRatingDoubleDropdownByCategoryChart groupByField="subCategoryId" />
              </ChartContextProvider>
            )}
            {/* Cumulative rating volume by product */}
            {!isProductEntity && <ReviewSummaryProductGrid tableComponent="review" />}
            {isProductEntity && <WeeklyRatingTable />}
          </>
        )}
      </Flex>
    </BasePageContainer>
  );
};

export default ReviewRatingsPage;
